<template>
  <div>
    <SpecImageChoose
      v-if="visible"
      :title="$l('dialog_title_skuImage') || '选择产品图片'"
      visible
      :evgSkuCode="evgSkuCode"
      @setImage="setImage"
      @close="close"
    />
  </div>
</template>

<script>
import SpecImageChoose from '../spec-image-choose'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { SpecImageChoose },
  mixins: [EditLoading],
  props: {
    evgSkuSpecCode: { type: String, default: '' },
    evgSkuCode: { type: String, default: '' },
    visible: { type: Boolean, default: false },
  },
  methods: {
    async setImage({ displayImageCode, displayImageUrl } = {}) {
      if (!displayImageCode) return
      const params = {
        evgSkuSpecCode: this.evgSkuSpecCode,
        defaultImageCode: displayImageCode,
        defaultImageUrl: displayImageUrl,
      }

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgSkuSpecEditImageApi({ ...params })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_update_no') || '修改失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_update_ok') || '修改成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.close()
    },
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>

<style scoped></style>
